import { makeStyles } from "@mui/styles";
import {
  SURVEY_COLORS,
  SURVEY_TYPOGRAPHY,
  SURVEY_SPACING,
  SURVEY_MIXINS,
  DROPDOWN_STYLES,
} from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
export const useDropdownQuestionStyles = makeStyles(() => ({
  container: {
    marginTop: SURVEY_SPACING.QUESTION_MARGIN_TOP,
    width: "100%",
  },
  labelContainer: {
    paddingBottom: SURVEY_SPACING.LABEL_PADDING_BOTTOM,
  },
  label: SURVEY_MIXINS.questionLabel,
  requiredAsterisk: SURVEY_MIXINS.requiredAsterisk,
  select: {
    width: "100%",
    height: "32px",
    fontWeight: "400 !important",
    border: "1px solid !important",
    borderRadius: "0px",
    fontSize: `${DROPDOWN_STYLES.fontSize} !important`,
    fontFamily: `${DROPDOWN_STYLES.fontFamily} !important`,
    color: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    backgroundColor: "#ffffff",
    "&::placeholder": {
      fontSize: `${DROPDOWN_STYLES.fontSize} !important`,
      fontFamily: `${DROPDOWN_STYLES.fontFamily} !important`,
      fontWeight: "400 !important",
      opacity: "0.6 !important",
    },
    "& .k-input-value-text": {
      fontSize: `${DROPDOWN_STYLES.fontSize} !important`,
      fontFamily: `${DROPDOWN_STYLES.fontFamily} !important`,
    },
    "&.k-focus": {
      backgroundColor: "#ffffff",
      border: "2px solid !important",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },
  selectError: {
    "& .k-dropdown-wrap": {
      border: `2px solid ${SURVEY_COLORS.ERROR} !important`,
    },
    "& .k-state-focused": {
      border: `2px solid ${SURVEY_COLORS.ERROR} !important`,
    },
  },
  selectPopup: {
    zIndex: 10000,
    "& .k-list-container": {
      backgroundColor: "#ffffff",
    },
    "& .k-list-optionlabel, & .k-list-item": {
      backgroundColor: "#ffffff",
      borderRadius: "0px !important",
      padding: "6px",
      color: SURVEY_COLORS.TEXT_PRIMARY,
      fontSize: `${SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT} !important`,
      "&:hover": {
        backgroundColor: "#E6E6E6 !important",
        border: `1px solid ${SURVEY_COLORS.SELECT_BORDER} !important`,
      },
    },
  },
}));
